//import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

import mApp from "@/modules/app";
import mMenu from "@/modules/menu";
import mRest from "@/modules/rest";
import mUtils from "@/modules/utils";

import { MENU_TYPE } from "@/modules/enums";

export default {
  state: {
    initialized: false,
    menuDownload: false,
    menuSchemaType: undefined,

    data: {},
    currentMenuName: undefined,
    currentTable: undefined,

    timeCounter: undefined,
    timeCounterStartTimestamp: undefined,

    timeLimit: undefined,
    timeRemain: undefined,
    timeOutNotification: undefined,
    timeOutNotificationTime: [],

    numberOfGuests: undefined,
    numberOfGuestsLastUpdated: undefined,

    order: undefined,
    orderLastUpdated: undefined,

    allItems: [],
    allOptions: [],

    logs: [],
  },

  getters: {
    padTheme: state => {
      let _theme = {};
      if (state.data && state.data.theme) _theme = { ...state.data.theme };
      if (!_theme.primary) _theme.primary = "#000000";
      if (!_theme.primaryText) _theme.primaryText = "#FFFFFF";
      if (!_theme.secondary) _theme.secondary = "#666666";
      if (!_theme.secondaryText) _theme.secondaryText = "#FFFFFF";
      if (!_theme.accent) _theme.accent = "#C0C0C0";
      if (!_theme.accentText) _theme.accentText = "#000000";

      return _theme;
    },

    padSetting: state => {
      let _setting = {};
      if (state.data && state.data.setting) _setting = state.data.setting;

      return _setting;
    },

    padNews: state => {
      let _news = [];
      if (state.data && state.data.news) {
        //_news = state.data.news;
        state.data.news.forEach(x => {
          if (x.fileSize > 0 || x.altUrl) _news.push(x);
        });
      }

      return _news;
    },

    padHomeSchema: state => {
      let _schema = {};
      if (state.data && state.data.pageSchema && state.data.pageSchema.home) _schema = state.data.pageSchema.home;

      return _schema;
    },

    padMenuSchema: state => {
      let _schema = {};
      if (state.data && state.data.pageSchema && state.data.pageSchema.menu) _schema = state.data.pageSchema.menu;

      return _schema;
    },

    padPopupSchema: state => {
      let _schema = {};
      if (state.data && state.data.pageSchema && state.data.pageSchema.popUp) _schema = state.data.pageSchema.popUp;

      return _schema;
    },

    padTableSchema: (state, getters) => {
      let _schema = {};
      if (state.data && state.data.pageSchema && state.data.pageSchema.table) _schema = state.data.pageSchema.table;
      else if (getters.padPopupSchema) _schema = getters.padPopupSchema;

      return _schema;
    },

    padCartSchema: (state, getters) => {
      let _schema = {};
      if (state.data && state.data.pageSchema && state.data.pageSchema.cart) _schema = state.data.pageSchema.cart;
      else if (getters.padPopupSchema) _schema = getters.padPopupSchema;

      return _schema;
    },

    padMenu: (state, getters, rootState) => {
      let menu = [];
      let _allItems = [];
      let _allOptions = [];
      console.log("currentMenuName", state.currentMenuName);
      if (state.currentMenuName && state.data && state.data.menuSchema) {
        let mSchema = state.data.menuSchema.find(x => x.name == state.currentMenuName);
        console.log("mSchema", mSchema);
        if (mSchema) {
          let mClassifies;
          if (state.menuSchemaType == 2) {
            if (mSchema.type == "T" && mSchema.child) mClassifies = mSchema.child;
          } else mClassifies = mSchema.classifies;

          console.log("mClassifies", mClassifies);
          if (mClassifies) {
            mClassifies.forEach(cf => {
              let n_cf = {
                name: cf.name,
                view: cf.view,
                image: cf.image,
                categories: [],
                authentication: cf.authentication,
              };
              n_cf.getText = function () {
                if (cf.text) {
                  if (typeof cf.text == "string") return cf.text;
                  else if (typeof cf.text == "object") {
                    if (rootState.languageSelected) {
                      let lang = rootState.languageSelected;
                      if (cf.text[lang.locale]) return cf.text[lang.locale];
                      else if (cf.text["def"]) return cf.text["def"];
                    }
                  }
                }
                return cf.name;
              };

              let mCategories;
              if (state.menuSchemaType == 2) {
                if (cf.type == "C" || cf.type == "V") mCategories = cf.child;
              } else mCategories = cf.categories;

              mCategories.forEach(x => {
                let cat = false;
                if (state.menuSchemaType == 2) {
                  if (x.type == "C") {
                    cat = getters.menu.find(y => y.ID == x.catid);
                  } else {
                    cat = {
                      ID: -999,
                      descr: x.name,
                      descr1: x.name,
                      descr2: x.name,
                      fullID: "-999",
                    };
                  }
                } else cat = getters.menu.find(y => y.ID == x.id);

                if (cat) {
                  let n_cat = mUtils.cloneObject(cat);
                  n_cat.key = uuidv4();
                  n_cat.getText = function () {
                    if (x.text && Array.isArray(x.text) && x.text.length > 0) {
                      if (typeof x.text == "string") return x.text;
                      else if (typeof x.text == "object") {
                        if (rootState.languageSelected) {
                          let lang = rootState.languageSelected;
                          if (x.text[lang.locale]) return x.text[lang.locale];
                          else if (x.text["def"]) return x.text["def"];
                        }
                      }
                    } else {
                      if (rootState.descrIndex == 2) return cat.descr2;
                      else if (rootState.descrIndex == 1) return cat.descr1;
                      else return cat.descr;
                    }
                  };
                  let n_items = [];
                  let mItems;
                  if (state.menuSchemaType == 2) mItems = x.child;
                  else if (state.menuSchemaType == 1) mItems = x.items;

                  if (mItems && mItems.length > 0) {
                    mItems.forEach(xi => {
                      let item = false;

                      if (xi.itemid) item = getters.menuItems.find(ii => ii.ID == xi.itemid);
                      else if (xi.id) item = getters.menuItems.find(ii => ii.ID == xi.id);

                      if (item) {
                        let itemDialog =
                          (item.options && item.options.length > 0) || xi?.image?.fileSize > 0 || xi?.image?.altUrl
                            ? true
                            : false;
                        if (!itemDialog) itemDialog = xi.itemDialog == "show" ? true : x.itemDialog == "show";

                        let n_item = mUtils.cloneObject(item);
                        n_item.menuSchema = xi;
                        n_item.key = uuidv4();
                        n_item.catKey = n_cat.key;
                        n_item.itemDialog = itemDialog;
                        n_item.xi_itemDialog = xi.itemDialog;
                        n_item.x_itemDialog = x.itemDialog;
                        n_items.push(n_item);

                        /*
                        _allItems.push(n_item);
                        if (n_item.options) {
                          n_item.options.forEach(iog => {
                            if (iog.items) {
                              iog.items.forEach(iogi => {
                                _allOptions.push(iogi);
                              });
                            }
                          });
                        }
                        */
                      }
                    });
                  } else if (/*state.menuSchemaType == 1*/cat.items && cat.items.length > 0) {
                    cat.items.forEach(item => {
                      let itemDialog = item.options && item.options.length > 0 ? true : false;
                      if (!itemDialog) itemDialog = x.itemDialog == "show";
                      let n_item = mUtils.cloneObject(item);
                      n_item.key = uuidv4();
                      n_item.catKey = n_cat.key;
                      n_item.itemDialog = itemDialog;
                      n_item.x_itemDialog = x.itemDialog;
                      n_items.push(n_item);

                      _allItems.push(n_item);

                      /*
                      _allItems.push(n_item);
                      if (n_item.options) {
                        n_item.options.forEach(iog => {
                          if (iog.items) {
                            iog.items.forEach(iogi => {
                              _allOptions.push(iogi);
                            });
                          }
                        });
                      }
                      */
                    });
                  }

                  //console.log("n_items", n_items);
                  if (n_items.length > 0) {
                    n_cat.menuSchema = x;
                    n_cat.classify = { name: cf.name, new: cf.view };
                    n_cat.items = n_items;
                    n_cf.categories.push(n_cat);
                  }
                }
              });
              if (n_cf.categories.length > 0) menu.push(n_cf);
            });
          }
        }
      }

      state.allItems = _allItems;
      state.allOptions = _allOptions;

      return menu;
    },

    padMenuMessage: (state, getters, rootState) => {
      let message;

      if (state.currentMenuName && state.data && state.data.menuSchema) {
        let mSchema = state.data.menuSchema.find(x => x.name == state.currentMenuName);
        if (mSchema) {
          let text = undefined;
          let style = undefined;
          if (mSchema.messages?.menu?.text) {
            let menuText = mSchema.messages.menu.text;
            text = menuText.def;
            style = mSchema.messages?.menu?.style;
            if (rootState.languageSelected) {
              let lang = rootState.languageSelected;
              if (menuText[lang.locale]) {
                text = menuText[lang.locale];
              }
            }
            if (text) message = { text: text, style: style };
          }
        }
      }

      if (!message) {
        message = getters.padMessage("menu");
      }

      return message;
    },

    padTableGroupID: (state, getters) => {
      let _id = 0;
      if (getters.padSetting.tableGroupID) {
        _id = getters.padSetting.tableGroupID;
      }
      return _id;
    },

    padPriceLevel: (state, getters) => {
      let _pl = 0;
      if (getters.padSetting.priceLevel) {
        _pl = getters.padSetting.priceLevel;
      }
      return _pl;
    },

    padStartMenuAuthentication: (state, getters) => {
      return getters.padSetting.startMenuAuthentication === true;
    },

    padCheckoutAuthentication: (state, getters) => {
      if (getters.padSetting.checkoutAuthentication === true) return "system_pin";
      else if (
        getters.padSetting.checkoutAuthentication == "system_pin" ||
        getters.padSetting.checkoutAuthentication == "employee_pin"
      )
        return getters.padSetting.checkoutAuthentication;
      else return false;
    },

    padCallService: (state, getters) => {
      return getters.padSetting.callService;
    },

    padTables: state => {
      return state.data.tables;
    },

    padMessage: (state, getters, rootState) => messageName => {
      let text = undefined;
      let style = undefined;
      if (messageName && getters.padSetting.messages && getters.padSetting.messages[messageName]?.text) {
        let messageText = getters.padSetting.messages[messageName].text;
        text = messageText.def;
        style = getters.padSetting.messages[messageName].style;
        if (rootState.languageSelected) {
          let lang = rootState.languageSelected;
          if (messageText[lang.locale]) {
            text = messageText[lang.locale];
          }
        }
      }
      return { text: text, style: style };
    },
  },

  mutations: {
    PAD_INIT(state, payload) {
      state.initialized = payload;
    },

    PAD_MENU_DOWNLOAD(state, payload) {
      state.menuDownload = payload;
    },

    PAD_DATA(state, payload) {
      state.data = payload;
    },

    PAD_CURRENT_TABLE(state, payload) {
      state.currentTable = payload;
      localStorage.setItem("PAD_CURRENT_TABLE_ID", state.currentTable ? state.currentTable.ID.toString() : "");
    },

    PAD_CURRENT_MENU_NAME(state, payload) {
      state.currentMenuName = payload;
    },

    PAD_TIME_REMAIN(state, payload) {
      state.timeRemain = payload;
    },

    PAD_TIME_COUNTER_START(state, payload) {
      state.timeCounterStartTimestamp = Date.now();
      state.timeLimit = payload;
      state.timeRemain = payload;
    },

    PAD_NUM_OF_GUESTS(state, payload) {
      //console.log("PAD_NUM_OF_GUESTS", payload);
      state.numberOfGuests = payload;
      state.numberOfGuestsLastUpdated = Date.now();
    },

    PAD_TIME_NOTIFICATION(state, payload) {
      state.timeOutNotification = payload?.notification;
      if (payload?.notificationTime && Array.isArray(payload.notificationTime))
        state.timeOutNotificationTime = payload.notificationTime;
      else state.timeOutNotificationTime = [];
    },

    PAD_ORDER(state, payload) {
      //console.log("PAD_ORDER", payload);
      state.order = payload;
      state.orderLastUpdated = Date.now();

      if (state.order?.openTime) {
        let _openTimestamp = Date.parse(state.order.openTime);
        //console.log(state.timeCounterStartTimestamp, (new Date(state.timeCounterStartTimestamp)).toString());
        //console.log(_orderTimestamp, (new Date(_orderTimestamp)).toString());
        if (!isNaN(_openTimestamp)) {
          if (state.timeCounterStartTimestamp > _openTimestamp) {
            state.timeCounterStartTimestamp = _openTimestamp;

            let now = Date.now();
            let elapsedMin = Math.floor((now - state.timeCounterStartTimestamp) / 1000 / 60);
            let n_timeRemain = state.timeLimit - elapsedMin;
            if (n_timeRemain < 0 || isNaN(n_timeRemain)) n_timeRemain = 0;
            state.timeRemain = n_timeRemain;
          }
        }
      }
    },
  },

  actions: {
    PAD_INIT(context, appToken) {
      return mApp.apiPost(context.getters.apiUrl + "/orderpad/init", appToken).then(resp => {
        if (resp && resp.result == "ok") {
          context.rootState.launchTime = new Date();

          context.rootState.appInitialized = true;
          context.rootState.appToken = appToken;
          context.rootState.appData = resp.data;
          context.rootState.appSessionId = resp.sessionId;
          context.rootState.appSessionKey = resp.sessionKey;
        }
        return resp;
      });
    },

    async PAD_GET_DATA(context) {
      let padData = {};

      let resp = await mApp.apiPost(context.getters.apiUrl + "/orderpad/getdata", {
        sessionKey: context.rootState.Store.store.sessionKey,
        appKey: context.getters.appKey,
      });

      if (resp.result == "ok") {
        let _data = resp.data;
        padData.theme = _data?.theme;
        padData.setting = _data?.setting;
        padData.news = _data?.news;
        padData.pageSchema = _data?.pageSchema;
        padData.result = "ok";

        if (_data?.menuSchema2 && Array.isArray(_data.menuSchema2) && _data.menuSchema2.length > 0) {
          padData.menuSchema = _data?.menuSchema2;
          context.state.menuSchemaType = 2;
        } else {
          padData.menuSchema = _data?.menuSchema;
          context.state.menuSchemaType = 1;
        }

        if (padData.setting?.tableGroupID != null)
          padData.setting.tableGroupID = mUtils.toInt(padData.setting.tableGroupID);
        if (padData.setting?.priceLevel != null) padData.setting.priceLevel = mUtils.toInt(padData.setting.priceLevel);

        let tableGroupID = padData.setting?.tableGroupID;
        if (tableGroupID) {
          let res_tables = await mRest.getTable({ tableGroupID: padData.setting.tableGroupID });
          if (res_tables && res_tables.result == "ok") {
            padData.tables = res_tables.tables;

            let curTableID = localStorage.getItem("PAD_CURRENT_TABLE_ID");
            if (curTableID) {
              let i_curTableID = parseInt(curTableID);
              if (i_curTableID) {
                let curTable = padData.tables.find(x => x.ID == i_curTableID);
                if (curTable) context.commit("PAD_CURRENT_TABLE", curTable);
              }
            }
          }
        }
      }

      context.commit("PAD_DATA", padData);
    },

    async PAD_DOWNLOAD_MENU(context) {
      if (!await mApp.checkNetworkStatus(false)) {
        return { ok: false };
      }

      let menuType = MENU_TYPE.ORDERPAD;
      let resp = await mRest.getFullMenu(menuType, context.getters.padPriceLevel);
      if (resp && resp.result == "ok") {
        localStorage.setItem("PAD_MENU", JSON.stringify(resp.categories));

        let now = new Date();
        localStorage.setItem("PAD_MENU_DOWNLOADED", now.toUTCString());

        mMenu.prepareMenu(resp.categories);
        return { ok: true, menuUpdated: now };
      } else {
        return { ok: false };
      }
    },

    PAD_SEND_MESSAGE(context, message) {
      //console.log("PAD_SEND_MESSAGE", message);

      let currentTableID = context.rootState.Pad.currentTable?.ID;

      if (!message || !currentTableID) return;

      const wshost = "wss://wss.mrsdigi.com:8080/notify";
      let wsConnect = new WebSocket(wshost);
      if (wsConnect) {
        wsConnect.onopen = () => {
          //console.log(message);
          wsConnect.send(
            `{"publish":{"channel":"ORDERPAD:${context.getters.storeCompanyCode}", "data":{"service":"${message}", "tableID":${currentTableID}}}}`
          );
          wsConnect.close();

          //console.log("PAD_SEND_MESSAGE", "sent", message, currentTableID);
        };
      }
    },

    PAD_GET_NUM_OF_GUESTS(context) {
      if (context.state.numberOfGuestsLastUpdated) {
        let interval = Date.now() - context.state.numberOfGuestsLastUpdated;
        if (interval < 5000) return;
      }

      let currentTableID = context.rootState.Pad.currentTable?.ID;

      const wshost = "wss://wss.mrsdigi.com:8080/notify";
      let wsConnect = new WebSocket(wshost);
      if (wsConnect) {
        wsConnect.onopen = () => {
          wsConnect.send(
            `{"publish":{"channel":"ORDERPAD:${context.getters.storeCompanyCode}", "data":{"action":"getNumberOfGuests", "tableID":${currentTableID}}}}`
          );
          wsConnect.close();
        };
      }
    },

    PAD_GET_ORDER(context) {
      if (context.state.orderLastUpdated) {
        let interval = Date.now() - context.state.orderLastUpdated;
        if (interval < 1000) return;
      }

      let currentTableID = context.rootState.Pad.currentTable?.ID;

      const wshost = "wss://wss.mrsdigi.com:8080/notify";
      let wsConnect = new WebSocket(wshost);
      if (wsConnect) {
        wsConnect.onopen = () => {
          wsConnect.send(
            `{"publish":{"channel":"ORDERPAD:${context.getters.storeCompanyCode}", "data":{"action":"getOrder", "tableID":${currentTableID}}}}`
          );
          wsConnect.close();
        };
      }
    },

    PAD_START_ORDER(context) {
      context.state.numberOfGuests = undefined;
      context.state.order = undefined;

      context.state.numberOfGuestsLastUpdated = undefined;
      context.state.orderLastUpdated = undefined;

      context.dispatch("PAD_GET_ORDER");
      context.dispatch("PAD_RESET_TIME_COUNTER");
    },

    PAD_RESET_TIME_COUNTER(context) {
      context.dispatch("PAD_STOP_TIME_COUNTER");

      let timeLimit = 0;
      let mSchema = context.state.data.menuSchema.find(x => x.name == context.state.currentMenuName);

      if (mSchema) {
        /*
        let seatTime = Number(mSchema.seatTime);
        let lastCall = Number(mSchema.lastCall);

        timeLimit = seatTime - lastCall;
        if (isNaN(timeLimit) || timeLimit < 0) timeLimit = 0;
        */
        timeLimit = Number(mSchema.timeLimit);
        if (isNaN(timeLimit) || timeLimit < 0) timeLimit = 0;

        context.commit("PAD_TIME_NOTIFICATION", {
          notification: mSchema.notification,
          notificationTime: mSchema.notificationTime,
        });
      }
      /*
      if (context.getters.padSetting && !isNaN(context.getters.padSetting.timeLimit))
        timeLimit = context.getters.padSetting.timeLimit;
      */
      context.commit("PAD_TIME_COUNTER_START", timeLimit);

      context.state.timeCounter = setInterval(() => {
        let timeRemain = context.state.timeRemain;
        if (timeRemain > 0) {
          let now = Date.now();
          let elapsedMin = Math.floor((now - context.state.timeCounterStartTimestamp) / 1000 / 60);
          let n_timeRemain = context.state.timeLimit - elapsedMin;
          if (n_timeRemain < 0 || isNaN(n_timeRemain)) n_timeRemain = 0;
          //console.log("timeRemain/now/elapsed", timeRemain, now, n_timeRemain, mUtils.toLocaleString(new Date()));
          context.commit("PAD_TIME_REMAIN", n_timeRemain);
        }
      }, 60 * 1000);
    },

    PAD_STOP_TIME_COUNTER(context) {
      if (context.state.timeCounter) clearInterval(context.state.timeCounter);
    },
  },
};
